import { showDeleteStudyLevelState } from "@/atoms";
import { useDeleteStudyLevelConfiguration } from "@/services/study-level-configuration";
import { Button } from "@mantine/core";
import { notifications } from "@mantine/notifications";
import { useQueryClient } from "@tanstack/react-query";
import { ModalLayout } from "moh-ui";
import { useRecoilState } from "recoil";
import useAuth from "@/hooks/useAuth";
import { useUserCouncil } from "@/hooks/useUserCouncil";

export default function DeleteStudyLevelModal() {
    const [show, setShow] = useRecoilState(showDeleteStudyLevelState);
    const { user } = useAuth();
  const council = useUserCouncil();
    const queryClient = useQueryClient();

    const {
        mutate: deleteStudyLevel,
        isPending: deletingStudyLevel,
    } = useDeleteStudyLevelConfiguration();

    const handleDeleteStudyLevel = async () => {
        if (!show?.studyLevel) return;

        deleteStudyLevel(show.studyLevel.id!, {
            onSuccess: (data) => {
                if (data.success) {
                    notifications.show({
                        title: "Success",
                        message: "Study Level deleted successfully",
                        color: "green",
                    });
                    if (user?.roles?.[0]?.roleName === "ADMINCOUNCIL") {
                        queryClient.invalidateQueries({
                            queryKey: ["study-level-configurations", council?.id],
                        })
                    } else {
                        queryClient.invalidateQueries({
                            queryKey: ["study-level-configurations"],
                        })
                    }
                    setShow(null);
                } else {
                    notifications.show({
                        title: "Error",
                        message: data.message || "Something went wrong",
                        color: "red",
                    });
                }
            },
            onError: (error) => {
                console.error(error);
                notifications.show({
                    title: "Error",
                    message: error.message || "An error occurred while deleting the study level",
                    color: "red",
                });
            },
        });
    };

    return (
        <ModalLayout
            open={Boolean(show?.show)}
            onClose={() => setShow(null)}
        >
            <div className="sm:flex sm:items-start">
                <div className="text-center sm:mt-0 sm:ml-4 sm:text-left">
                    <h3 className="text-lg font-medium leading-6 text-gray-900">Delete Study Level</h3>
                    <div className="mt-2">
                        <p className="text-sm text-gray-500">
                            Are you sure you want to delete this study level? This action cannot be undone.
                        </p>
                    </div>
                </div>
            </div>
            <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse gap-5 pt-4 border-t">
                <Button
                    color="red"
                    onClick={handleDeleteStudyLevel}
                    loading={deletingStudyLevel}
                >
                    Delete
                </Button>
                <Button
                    variant="outline"
                    onClick={() => setShow(null)}
                >
                    Cancel
                </Button>
            </div>
        </ModalLayout>
    );
}
